import {createApp, watch} from 'vue';
import {createPinia} from 'pinia';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import App from '@/App.vue';
import Router from '@/router';
import {polyfillCountryFlagEmojis} from "country-flag-emoji-polyfill";
import {createAppI18n, tt} from '@/i18n';
import VueCookies from 'vue3-cookies';
import '@/axios'
import {useBaseStore} from '@/stores/BaseStore';
import '@/index.css';
import 'font-awesome/css/font-awesome.css';
import {getToken} from "@/Helper";

polyfillCountryFlagEmojis();
const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

const isMapModule = () => {
    const hash = window.location.hash;
    const parts = hash.split('/');
    return parts[1].slice(0, 3) === 'map';
}
export const i18n = createAppI18n(isMapModule() ? 'map' : 'dashboard');

const app = createApp(App);
app.use(pinia);
const store = useBaseStore();

// Now you can run your async function that depends on Pinia.
async function init() {
    await store.init(getToken())
    app.use(Router);
    app.use(VueCookies);
    app.use(i18n);
    app.config.globalProperties.$tt = tt;
    app.mount('#app');
}

init();

//handle language change
watch(() => store.language, async newLang => {
    if (newLang && newLang.code) {
        i18n.global.locale.value = newLang.code
        if (newLang.is_rtl) {
            document.documentElement.setAttribute('dir', 'rtl');
        } else {
            document.documentElement.setAttribute('dir', 'ltr');
        }
    }
})

